import { Component, Host, h } from "@stencil/core";

/**
 * @slot title - Slot for the headline (`<h2>` or `<h3>`)
 * @slot subtitle - Slot for the subtitle (`<p>` or `<div>`)
 */
@Component({
    tag: "ux-iws-nb-intermediate-title",
    styleUrl: "nb-intermediate-title.scss",
    shadow: false,
})
export class NbIntermediateTitle {
    render() {
        return (
            <Host>
                <header>
                    <slot name="title" />
                    <slot name="subtitle" />
                </header>
            </Host>
        );
    }
}
